<div
  oui-dialog-title
  class="title">
  Mise à jour de la capacité à supporter les pertes
</div>

<div
  oui-dialog-content
  class="content">
  @if (data.isValid) {
    <div class="icon-text">
      <app-qpi-icon-box
        icon="trending_down"
        [completed]="true"></app-qpi-icon-box>

      <span
        >La <strong>capacité à supporter les pertes a été recalculée</strong> suite aux modifications apportées au recueil
        d'informations.</span
      >
    </div>
    <span>Veuillez vérifier la synthèse du profil investisseur avant l'envoi en signature.</span>
  } @else {
    <div class="icon-text">
      <app-qpi-icon-box
        icon="trending_down"
        [completed]="false"></app-qpi-icon-box>

      <span
        >Suite aux modifications apportées au recueil d'informations,
        <strong>la capacité à supporter les pertes n'est plus calculable</strong></span
      >
    </div>
    <span class="warning-emphasis">{{ errorMessage }}</span>
  }

  <oui-button
    class="close-btn"
    oui-dialog-close
    >J'ai compris</oui-button
  >
</div>
